<template>
  <div :class="['owc-feature-box', { 'owc-feature-box--dark': isDarkModeOn }]">
    <ValidationBoxWrapper v-if="isEditMode">
      <slot slot="validation-box" name="validation-box" />
    </ValidationBoxWrapper>
    <div class="wb-grid-container">
      <SlotContainer refName="slot-items" class="owc-feature-box__items wb-grid-row">
        <slot></slot>
      </SlotContainer>
      <FeatureBoxButton
        class="owc-feature-box__button"
        v-if="linkData"
        v-test-id.ignore="'button'"
        :ctaData="linkData"
        :darkMode="isDarkModeOn"
      ></FeatureBoxButton>
    </div>
    <div v-if="footnotes" v-test-id.ignore="'footnotes'" class="owc-feature-box__footnotes wb-grid-container">
      <globalelem-footnote-component
        :module-id="moduleId"
        :theme="isDarkModeOn ? 'dark' : 'light'"
      ></globalelem-footnote-component>
    </div>
  </div>
</template>

<script lang="ts">
/**
 * TODO: Documentation
 * `Featurebox` - TODO.
 */
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import SlotContainer from '@owc-packages/SlotContainer/src/SlotContainer.vue';
import ValidationBoxWrapper from '@owc-packages/ValidationBox/src';
import { getFootnotesIfAvailable } from '@owc-utils/Footnotes/FootnotesUtils';
import { TestId } from '@owc-utils/TestIdDirective';
import { FeatureComponent } from './FeatureBox';
import OwcDataComponent from '@owc-utils/Mixins/OwcDataComponent';
import FeatureBoxButton from './FeatureBoxButton.vue';
import { setModuleId } from '../../_utils/Footnotes/FootnotesHelper';

export default (ComponentInitializeDispatcher as FeatureComponent).extend({
  name: 'owc-feature-box',
  components: {
    SlotContainer,
    ValidationBoxWrapper,
    FeatureBoxButton,
  },
  directives: {
    TestId,
  },
  mixins: [OwcDataComponent],
  computed: {
    linkData() {
      return this.componentData?.link;
    },
    isDarkModeOn() {
      return Boolean(this.componentData?.darkMode);
    },
    footnotes() {
      return getFootnotesIfAvailable(this.componentData)?.footnotes;
    },
    moduleId() {
      return setModuleId(this);
    },
  },
});
</script>

<style lang="scss">
@import '@owc-styles/utils/rte';

.owc-feature-box {
  padding: var(--wb-spacing-xl) 0;

  @include breakpoint-between(mq3, mq4) {
    padding-top: var(--wb-spacing-l);
  }

  .webcomponent {
    display: contents;
  }
  &--dark {
    color: var(--wb-white);

    background-color: var(--wb-black);
  }
  &__items {
    align-items: flex-end;

    @include breakpoint-from(mq5) {
      padding: 0;
    }
  }
  &__button {
    margin-top: var(--wb-spacing-m);
  }
  &__footnotes {
    margin-top: var(--wb-spacing-m);
  }
}
</style>
